import request from '@/utils/request'

let Accept_ordersApi = {

  /*接单员手续费列表*/
  list(data) {
    return request._post('/shop/plus.accept_orders.Index/index', data);
},
/*添加接单员手续费*/
add(data) {
    return request._post('/shop/plus.accept_orders.Index/add', data);
},
/*修改接单员手续费*/
edit(data) {
    return request._post('/shop/plus.accept_orders.Index/edit', data);
},
/*删除接单员手续费*/
del(data) {
    return request._post('/shop/plus.accept_orders.Index/del', data);
},
/*接单员手续费详情*/
detail(data) {
  return request._post('/shop/plus.accept_orders.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.accept_orders.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.accept_orders.Setting/getSetting', data, errorback);
    },
}
export default Accept_ordersApi;



// WEBPACK FOOTER //
// ./src/api/accept_orders.js